<style lang="scss" scoped>
@import '$vars';

.modal {
  z-index: 999;
}

.modal-container {
  max-width: 98vh;
  padding: 0;

  .modal-body {
    padding: 0
  }
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.videos-list {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 0.75rem;

  &__item {
    align-items: flex-start;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    padding: 0.75rem;
    transition: 0.2s all ease;

    img {
      margin: 0 auto;
      max-width: 6rem;
      height: auto;
    }

    span {
      align-self: stretch;
      font-size: 0.7rem;
      text-align: center;
    }

    &--selected {
      background-color: lighten($color-blue, 39%);
      border-radius: 8px;
      color: $color-blue;
      transition: 0.2s all ease;

      span {
        font-weight: normal;
      }
    }
  }

  &__file {
    display: flex;
    flex-direction: column;
    padding: 0.75rem;
    transition: 0.2s all ease;
    align-items: center;

    &__icon {
      padding: 0.75rem;
      transition: 0.2s all ease;
      max-width: 4rem;
    }
  }
}
</style>

<template>
  <main class="modal active">
    <a
      aria-label="Close"
      class="modal-overlay"
      @click="$emit('close', true)"
    >
    </a>

    <div class="modal-container">
      <div class="modal-body">
        <div class='embed-container'>
          <iframe
            :src="`https://www.youtube.com/embed/${videos[localWhich].hash}`"
            frameborder="0"
            allowfullscreen
          >
          </iframe>
        </div>
      </div>

      <div class="videos-list">
        <a v-for="(file, index) in files"
        :key="`video-tutorial-${index}`"
        :href="files[index].path"
        class="videos-list__file"
        download>
          <dr-icon
            :fill="'blue'"
            name="reports"
            class="videos-list__file__icon"
          />
          {{files[index].name}}
        </a>
        <div
          v-for="(video, index) in videos"
          :key="`video-tutorial-${index}`"
          :class="localWhich === index && 'videos-list__item--selected'"
          class="videos-list__item"
          @click="localWhich = index"
        >
          <img
            :src="`https://img.youtube.com/vi/${videos[index].hash}/0.jpg`"
          />
          <span>{{ videos[index].name }}</span>
        </div>
      </div>

      <div class="modal-footer text-right">
        <a @click="$emit('close', true)">Fechar tutorial</a>
      </div>
    </div>
  </main>
</template>

<script>
import pdfToDownload from './../assets/files/guia_pratico_drconecta_2022.pdf'

export default {
  name: 'DrTutorial',

  props: {
    which: {
      type: Number,
      required: true,
      default: () => 0
    }
  },

  data () {
    return {
      localWhich: null,
      videos: [
        {
          name: 'Configure sua Conta',
          hash: 'HROeErv_0PI'
        },
        {
          name: 'Configure sua Agenda',
          hash: 'iQiu4Js3NVc'
        },
        {
          name: 'Consulta via Telemedicina',
          hash: 'a5hEl9WMeAg'
        }
      ],
      files: [
        {
          name: 'Guia Prático',
          path: pdfToDownload
        }
      ]
    }
  },

  watch: {
    which: {
      deep: false,
      immediate: true,
      handler (value) {
        this.localWhich = value
      }
    }
  },

  destroyed () {
    this.localWhich = null
  }
}
</script>
